import {
  constructContractIssuer,
  constructSelfRegisterKey,
  constructSingleReadClaim,
  prepareQueueContractCall,
  toHex
} from "@coinweb/contract-kit";
const constructCall = (contractId, methodName, methodArgs, cost, auth = true) => {
  const issuer = constructContractIssuer(contractId);
  return {
    contract_input: {
      data: [methodName, ...methodArgs],
      cost: toHex(cost),
      authenticated: auth
    },
    contract_ref: {
      explicit: [],
      stored: [constructSingleReadClaim(issuer, constructSelfRegisterKey())]
    }
  };
};
const constructQueueCall = (contractId, methodName, methodArgs, cost, auth = true) => {
  const issuer = constructContractIssuer(contractId);
  return prepareQueueContractCall(issuer, { methodName, methodArgs }, cost, auth);
};
export {
  constructCall,
  constructQueueCall
};
//# sourceMappingURL=constructCall.js.map